import Types from "./types";
import AssessmentServiceApi from "../../services/assessment-api";

const resetPassword = (params) => {
  return function () {
    return AssessmentServiceApi.resetPassword(params)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

export { resetPassword };
